import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import Pagination from "../../Components/layouts/pagination";
import NurseryBatchTable from "./Nursery Management/nursery_table";
import getFilteredURL from "../../Components/Functions/filters.getUrl";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import DynamicFilterInput from "../../Components/layouts/filter.inpit";
import { FcStackOfPhotos } from "react-icons/fc";
import { FaLeaf } from "react-icons/fa6";
import DynamicFilterSelect from "../../Components/layouts/filter.select";
import { useDispatch, useSelector } from "react-redux";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import LoadingPage from "../../Components/layouts/loading";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";
import { useNavigate, useSearchParams } from "react-router-dom";
import { setNurseryPage } from "../../redux/Pagination/pagination"

const FarmNurseryManagement = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const dispatch = useDispatch();
  const page = useSelector((state) => state.pagination.nurseryPage);
  // const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [farmName, setFarmName] = useState();
  const role = store?.Role;
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    batchName: "",
    farmName: "",
    archieveData: 0,
  });
  const navigate = useNavigate();
  const [checkClientAccess, setCheckClientAccess] = useState({
    workOrder: false,
    isHandOverCompleted: false,
    isClient: store?.Role == process.env.REACT_APP_ROLE_CLIENT,
  });

  const [themeSet, setThemeSet] = useState("");
  const [searchParams] = useSearchParams();
  const theme = searchParams.get("theme");
  // const [showArchived, setShowArchived] = useState(false);
  const showArchived = filters.archieveData === 1;

  useEffect(() => {
    setThemeSet(theme);
  }, [theme]);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/projectTracking/getProjectTracking", 1)
    )
      .then((res) => {
        if (res.status === 200) {
          let access = {
            isHandOverCompleted: false,
            workOrder: false,
            isClient: false,
          };

          if (res?.data?.clientHandover?.handOverCertificate) {
            access.isHandOverCompleted = true;
          }
          if (res?.data?.projectTrackingData?.[0]?.workOrderUpload) {
            access.workOrder = true;
          }
          if (store?.Role == process.env.REACT_APP_ROLE_CLIENT) {
            access.isClient = true;
          }
          setCheckClientAccess(access);
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/nurseryManagement/getNurseryManagement", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data.nurseryManagementCount / 50));
        } else {
          Toast("error", "Error while getting Attendance!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/clientProject/getCpNameForClients/")
      .then((res) => {
        if (res.status === 200) {
          setFarmName(res?.data?.clientProjectsData);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);
  if (loading) {
    return <LoadingPage />;
  }

  const navigateTocreateBatch = () => {
    if (
      checkClientAccess?.isClient &&
      !checkClientAccess?.isHandOverCompleted
    ) {
      data?.nurseryManagementData?.length > 0
        ? Toast(
            "error",
            "Your handover process is not yet complete, so you cannot create a new nursery batch at this time. Please contact the Kryzen support team for further details."
          )
        : navigate("/farm-nursery-management/new-batch");
    } else {
      navigate("/farm-nursery-management/new-batch");
    }
  };
  /*
     {checkClientAccess?.isClient &&
      (!checkClientAccess?.workOrder ||
        !checkClientAccess?.isHandOverCompleted) ? (
        <div className="page-wrapper">
          <div className="page-body">
            <div className="container-xxl d-flex flex-column justify-content-center">
              <div className="empty">
                <p className="empty-title">
                  {!checkClientAccess?.isHandOverCompleted &&
                  checkClientAccess?.workOrder
                    ? "Your farm handover is not completed yet."
                    : "Your farm has not been deployed yet."}
                </p>
                <p className="empty-subtitle text-muted">
                  Contact your account manager.
                </p>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      ) : (
  */
  return (
    <>
      {checkClientAccess?.isClient && !checkClientAccess?.workOrder ? (
        <div className="page-wrapper">
          <div className="page-body">
            <div className="container-xxl d-flex flex-column justify-content-center">
              <div className="empty">
                <p className="empty-title">
                  Your farm has not been deployed yet.
                </p>
                <p className="empty-subtitle text-muted">
                  Contact your account manager.
                </p>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      ) : (
        <div className="page">
          <div className="page-wrapper">
            <div className="container-xxl">
              <div className="page-header d-print-none">
                <div className="row align-items-center">
                  <div className="col-md-8">
                    <h2 className="page-title mb-1">
                      <FcStackOfPhotos className="fs-2  me-1" /> Nursery
                      Management
                    </h2>
                    <h4 className="text-muted">
                      {/* <StepRoutes /> */} Track & manage your nursery.
                    </h4>
                  </div>
                  <div className="col-md-4 d-none d-sm-block">
                    <div className="btn-list justify-content-end">
                      <button
                        className="btn btn-primary"
                        onClick={navigateTocreateBatch}
                      >
                        {" "}
                        <FaLeaf className="fs-3 me-2" />
                        START A NEW BATCH
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div
                            className={`accordion-body pt-0 ${
                              themeSet === "dark" ? "text-light" : ""
                            }`}
                          >
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search batch name:"
                                  value={filters.batchName}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      batchName: e.target.value,
                                    })
                                  }
                                  placeholder="search name..."
                                />
                              </div>
                              {(store.Role ===
                                process.env.REACT_APP_ROLE_ADMIN_S ||
                                store.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN) && (
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Search farm name:"
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        farmName: e.target.value,
                                      })
                                    }
                                    value={filters.farmName}
                                  >
                                    <option value="">select all</option>

                                    {farmName &&
                                      farmName?.map((state, index) => (
                                        <option
                                          key={index}
                                          value={state?.clientName}
                                        >
                                          {state?.clientName}
                                        </option>
                                      ))}
                                  </DynamicFilterSelect>
                                </div>
                              )}

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          batchName: "",
                                          farmName: "",
                                          archieveData: 0,
                                        });
                                        dispatch(setNurseryPage(1));
                                        setRefresh((r) => !r);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`accordion-body d-none d-md-block ${
                            themeSet === "dark" ? "text-light" : ""
                          }`}
                        >
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search batch name:"
                                value={filters.batchName}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    batchName: e.target.value,
                                  })
                                }
                                placeholder="search name..."
                              />
                            </div>

                            {(store.Role ===
                              process.env.REACT_APP_ROLE_ADMIN_S ||
                              store.Role ===
                                process.env.REACT_APP_ROLE_ADMIN) && (
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search farm name:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      farmName: e.target.value,
                                    })
                                  }
                                  value={filters.farmName}
                                >
                                  <option value="">select all</option>

                                  {farmName &&
                                    farmName?.map((state, index) => (
                                      <option
                                        key={index}
                                        value={state?.clientName}
                                      >
                                        {state?.clientName}
                                      </option>
                                    ))}
                                </DynamicFilterSelect>
                              </div>
                            )}

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        batchName: "",
                                        farmName: "",
                                        archieveData: 0,
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 mb-3">
                    {!showArchived && (
                      <button
                        onClick={() => {
                          setFilters((prev) => ({ ...prev, archieveData: 1 }));
                          dispatch(setNurseryPage(1));
                          setRefresh((r) => !r);
                        }}
                        className="btn btn-outline btn-danger w-100"
                      >
                        Archived Cycles
                      </button>
                    )}
                    {showArchived && (
                      <button
                        onClick={() => {
                          setFilters((prev) => ({ ...prev, archieveData: 0 }));
                          dispatch(setNurseryPage(1));
                          setRefresh((r) => !r);
                        }}
                        className="btn btn-outline btn-success w-100"
                      >
                        Active Cycles
                      </button>
                    )}
                  </div>
                  <div className="d-none d-lg-block d-md-block">
                    <CustomViedoCard
                      viedoLink={"https://www.youtube.com/embed/a-ukfm07LLU"}
                      id={"model-viedo"}
                      name={"nursery management"}
                    ></CustomViedoCard>
                  </div>
                  <a
                    className="card mt-2 border-0"
                    href="https://www.hydroponicmasterclass.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="card-body p-0">
                      <img
                        className="d-none d-sm-block"
                        src="https://res.cloudinary.com/dezupfsqo/image/upload/v1733490461/1_z94wn3.jpg"
                        alt="plantvisittoday"
                      />
                    </div>
                  </a>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    {data && data?.nurseryManagementData && (
                      <NurseryBatchTable
                        BatchData={data?.nurseryManagementData}
                        currentPage={page}
                        itemsPerPage={50}
                        showArchived={showArchived}
                        onActionComplete={() => setRefresh((r) => !r)}
                      />
                    )}

                    <div className="btn-list justify-content-center">
                      <div className="d-lg-none d-md-none mt-3 mb-3">
                        <button
                          className="btn btn-primary"
                          onClick={navigateTocreateBatch}
                        >
                          {" "}
                          <FaLeaf className="fs-3 me-2" /> Start a new batch
                        </button>
                      </div>
                    </div>

                    <Pagination
                      page={page}
                      setPage={(newPage) => dispatch(setNurseryPage(newPage))}
                      totalPages={totalPages}
                      pageDatalength={data?.nurseryManagementData?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                  <a
                    className="card mt-2 border-0"
                    href="https://www.hydroponicmasterclass.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="card-body p-0">
                      <img
                        className="d-block d-sm-none"
                        src="https://res.cloudinary.com/dezupfsqo/image/upload/v1733490461/1_z94wn3.jpg"
                        alt="plantvisittoday"
                      />
                    </div>
                  </a>
                </div>
              </div>
              <div className="d-block d-md-none d-lg-none">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/a-ukfm07LLU"}
                  id={"model-viedo2"}
                  name={"nursery management"}
                ></CustomViedoCard>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
};

export default FarmNurseryManagement;
